module.exports = "<div class=\"wrapper\"> <ng-content></ng-content> </div> ";